var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"le-button-container",style:({
  width: _vm.width,
  height: _vm.height,
  fontSize: _vm.fontSize,
  background: _vm.background,
  lineHeight:_vm.height
}),on:{"click":function($event){return _vm.clickBtn()}}},[(_vm.loading)?_c('div',[_c('a-icon',{attrs:{"type":"loading"}})],1):_c('div',[_vm._v(_vm._s(_vm.txt))])])
}
var staticRenderFns = []

export { render, staticRenderFns }